import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { routeActions, push } from 'react-router-redux'
import Signup from './Signup'
import styles from '../_auth.css'
import * as authActions from 'services/auth/actions'
import { goToNext } from 'shared/routes'

const mapStateToProps = () => ({})

const mapDispatchToActions = {
  ...authActions,
  push,
  navigateTo: routeActions.push,
}

export class SignupPage extends Component {

  static propTypes = {
    push: PropTypes.func,
    dispatch: PropTypes.func,
    location: PropTypes.shape({
      search: PropTypes.string,
      query: PropTypes.object,
    }),
    navigateTo: PropTypes.func,
  }

  handleClickLogin = () => {
    const { location: { search }} = this.props
    this.props.push({ pathname: '/auth/login', search })
  }

  handleSignupSuccess = () => {
    const next = this.props.location.query.next
    goToNext(next, '/account/personalization/')
  }

  handleFacebookLoginSuccess = () => {
    const next = this.props.location.query.next
    goToNext(next, '/account/personalization/')
  }

  handleSignupConsents = () => {
    const { location: { search }} = this.props
    this.props.navigateTo(`/privacy_center/consents${search}`)
  }

  render () {
    return (
      <div className={styles.container}>
        <Signup
          onClickLogin={this.handleClickLogin}
          onSignupSuccess={this.handleSignupSuccess}
          onFacebookLoginSuccess={this.handleFacebookLoginSuccess}
          onSignupConsents={this.handleSignupConsents}
        />
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToActions)(SignupPage)



// WEBPACK FOOTER //
// ./src/components/auth/signup/SignupPage.jsx